import { render, staticRenderFns } from "./company-edit.vue?vue&type=template&id=87d58b0c&scoped=true"
import script from "./company-edit.vue?vue&type=script&lang=js"
export * from "./company-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d58b0c",
  null
  
)

export default component.exports